/**
 * Trailing "clear" (✕) icon button for editable single-value subfields (CZNA-234).
 *
 * Renders a small Stripes IconButton that wipes the field's value. Returns
 * `null` when `visible` is false so call sites can pass `visible={!!value}`
 * inline without an extra conditional — the button only appears once a field
 * holds a non-empty value. Read-only / disabled subfields simply never pass an
 * `onClear`, so they get no button.
 *
 * Multi-value fields keep their own per-chip removal and do NOT use this.
 */
import React from 'react';
import { useIntl } from 'react-intl';
import { IconButton } from '@folio/stripes/components';
var ClearFieldButton = function (_a) {
    var onClear = _a.onClear, _b = _a.visible, visible = _b === void 0 ? true : _b;
    var intl = useIntl();
    if (!visible)
        return null;
    return (React.createElement(IconButton, { icon: "times-circle-solid", onClick: onClear, "aria-label": intl.formatMessage({ id: 'ui-czna-authorities.form.clearField' }), "data-testid": "clear-field-button" }));
};
export default ClearFieldButton;
